import React from 'react';

const SeaViewIcon = ({width = 20}) => (
  <svg aria-hidden={true} width={width} height={width} fill="none" viewBox="0 0 24 22">
    <path stroke="currentColor" strokeWidth={2} strokeLinecap="round" d="M3 15C5.48276 15 7.34483 12 7.34483 12C7.34483 12 9.2069 15 11.6897 15C14.1724 15 16.6552 12 16.6552 12C16.6552 12 19.1379 15 21 15"/> 
    <path stroke="currentColor" strokeWidth={2} strokeLinecap="round" d="M3 20C5.48276 20 7.34483 17 7.34483 17C7.34483 17 9.2069 20 11.6897 20C14.1724 20 16.6552 17 16.6552 17C16.6552 17 19.1379 20 21 20"/> 
    <path stroke="currentColor" strokeWidth={2} strokeLinecap="round" d="M19 10C19 6.13401 15.866 3 12 3C8.13401 3 5 6.13401 5 10"/> 
  </svg>
);

export default SeaViewIcon;